// extracted by mini-css-extract-plugin
module.exports = {"container":"InputWithPrefix_container__2YHXo","label":"InputWithPrefix_label__1Qwg2","prefix":"InputWithPrefix_prefix__2C0Xz"};